export var BrandId;
(function (BrandId) {
    BrandId["ACTALENT"] = "ACTALENT";
    BrandId["AEROTEK"] = "AEROTEK";
    BrandId["ASTON_CARTER"] = "ASTON_CARTER";
    BrandId["TEK_SYSTEMS"] = "TEK_SYSTEMS";
    BrandId["CONNECTED"] = "CONNECTED";
})(BrandId || (BrandId = {}));
export const ACTALENT = {
    id: BrandId.ACTALENT,
    name: "Actalent Services",
    origin: "https://www.actalentservices.com",
    talentAssistantOrigin: "https://talentassistant.actalentservices.com",
    privacyPolicyUrl: "/en/privacy-notices",
    termsAndConditionsUrl: "/en/terms-and-conditions",
    hostPattern: /actalentservices\./i,
    minBookingBufferMinutes: 60,
    maxBookingBusinessDays: 10,
    address: "7301 Pkwy Dr S 4th Floor, Hanover MD 21076",
    defaultActivityType: "Video Interview",
    allowedActivityTypes: ["Video Interview", "Other"],
    emailBranding: {
        label: "Actalent",
        headerBg: "#021A32",
        primary: "#021A32",
        secondary: "#004071", // Changed to match Aerotek color per UX feedback
        border: "#DD3113",
        footer: "dark",
        logo: "https://cdn.silverlabs.online/images/actalent-logo-banner.png",
        ctaButtonColor: "#021A32",
        ctaTextColor: "#FFFFFF",
        titleColor: "#454545",
        variants: {
            primary: {
                light: "#021A3214", // ~08 opacity
                muted: "#021A3233", // ~20 opacity
            },
            secondary: {
                light: "#00407126", // ~15 opacity - Updated to match Aerotek
                muted: "#0040714D", // ~30 opacity - Updated to match Aerotek
            },
        },
    },
};
export const AEROTEK = {
    id: BrandId.AEROTEK,
    name: "Aerotek",
    origin: "https://www.aerotek.com",
    talentAssistantOrigin: "https://talentassistant.aerotek.com",
    privacyPolicyUrl: "/en/privacy-notices",
    termsAndConditionsUrl: "/en/terms-conditions",
    hostPattern: /aerotek\./i,
    minBookingBufferMinutes: 60,
    maxBookingBusinessDays: 3,
    address: "7301 Parkway Dr S 3rd Floor, Hanover MD 21076",
    defaultActivityType: "Video Interview",
    allowedActivityTypes: ["Video Interview", "Other"],
    emailBranding: {
        label: "Aerotek",
        headerBg: "#F4F4F4",
        primary: "#035797",
        secondary: "#004071",
        border: "#E9E9E9",
        footer: "clear",
        logo: "https://cdn.silverlabs.online/images/aerotek-logo-banner.png",
        ctaButtonColor: "#035797",
        ctaTextColor: "#FFFFFF",
        titleColor: "#454545",
        variants: {
            primary: {
                light: "#03579714", // ~08 opacity
                muted: "#03579733", // ~20 opacity
            },
            secondary: {
                light: "#00407126", // ~15 opacity
                muted: "#0040714D", // ~30 opacity
            },
        },
    },
};
export const ASTON_CARTER = {
    id: BrandId.ASTON_CARTER,
    name: "Aston Carter",
    origin: "https://www.astoncarter.com",
    talentAssistantOrigin: "https://talentassistant.astoncarter.com",
    privacyPolicyUrl: "/en/privacy-notices",
    termsAndConditionsUrl: "/en/terms-and-conditions",
    hostPattern: /astoncarter\./i,
    minBookingBufferMinutes: 60,
    maxBookingBusinessDays: 10,
    address: "7312 Parkway Drive, Hanover, MD 21076",
    defaultActivityType: "Video Interview",
    allowedActivityTypes: ["Video Interview", "Other"],
    emailBranding: {
        label: "Aston Carter",
        headerBg: "#F4F4F4",
        primary: "#006B3F",
        secondary: "#006B3F",
        border: "#E9E9E9",
        footer: "clear",
        logo: "https://cdn.silverlabs.online/images/astoncarter-logo-banner.png",
        ctaButtonColor: "#006B3F",
        ctaTextColor: "#FFFFFF",
        titleColor: "#454545",
        variants: {
            primary: {
                light: "#006B3F14", // ~08 opacity
                muted: "#006B3F33", // ~20 opacity
            },
            secondary: {
                light: "#006B3F26", // ~15 opacity
                muted: "#006B3F4D", // ~30 opacity
            },
        },
    },
};
export const TEK_SYSTEMS = {
    id: BrandId.TEK_SYSTEMS,
    name: "TEKsystems",
    origin: "https://www.teksystems.com",
    talentAssistantOrigin: "https://talentassistant.teksystems.com",
    privacyPolicyUrl: "/privacy-notices",
    termsAndConditionsUrl: "https://www.allegisgroup.com/terms-and-conditions",
    hostPattern: /teksystems\./i,
    minBookingBufferMinutes: 60,
    maxBookingBusinessDays: 10,
    address: "7437 Race Road, Hanover, MD 21076",
    allowedActivityTypes: ["G2", "STP", "IOI", "Other"],
    emailBranding: {
        label: "TEKsystems",
        headerBg: "#FFFFFF",
        primary: "#C1D82F",
        secondary: "#0095D3",
        border: "#E9E9E9",
        footer: "clear",
        logo: "https://cdn.silverlabs.online/images/teksystems-logo-banner.png",
        buttonText: "#000000",
        ctaTextColor: "#021A32", // Special dark blue text for CTA buttons (uses primary green background)
        titleColor: "#454545",
        variants: {
            primary: {
                light: "#C1D82F14", // ~08 opacity
                muted: "#C1D82F33", // ~20 opacity
            },
            secondary: {
                light: "#0095D326", // ~15 opacity
                muted: "#0095D34D", // ~30 opacity
            },
        },
    },
};
export const CONNECTED = {
    id: BrandId.CONNECTED,
    name: "CONNECTED",
    origin: "https://www.connected.com",
    talentAssistantOrigin: "https://talentassistant.connected.com",
    privacyPolicyUrl: "/privacy-notices",
    termsAndConditionsUrl: "https://www.connected.com/terms-and-conditions",
    hostPattern: /connected\./i,
    minBookingBufferMinutes: 60,
    maxBookingBusinessDays: 10,
    address: "",
    allowedActivityTypes: ["G2", "STP", "Video Interview", "IOI", "Other"],
    emailBranding: {
        label: "CONNECTED",
        headerBg: "#E4F4FB",
        primary: "#1B5297",
        secondary: "#007FB9",
        border: "#C8D9E0",
        footer: "clear",
        logo: "https://cdn.silverlabs.online/images/connected-logo-banner.png",
        ctaButtonColor: "#1B5297",
        ctaTextColor: "#FFFFFF",
        titleColor: "#454545",
        sectionalBackground: "#EEF3F9",
        pillBackground: "#C6DFF3",
        badgeBackground: "#59B851",
        variants: {
            primary: {
                light: "#1B529714", // ~08 opacity
                muted: "#1B529733", // ~20 opacity
            },
            secondary: {
                light: "#007FB926", // ~15 opacity
                muted: "#007FB94D", // ~30 opacity
            },
        },
    },
};
export const BRANDS = [
    ACTALENT,
    AEROTEK,
    ASTON_CARTER,
    TEK_SYSTEMS,
    CONNECTED,
];
export const BRANDS_BY_ID = {
    [BrandId.ACTALENT]: ACTALENT,
    [BrandId.AEROTEK]: AEROTEK,
    [BrandId.ASTON_CARTER]: ASTON_CARTER,
    [BrandId.TEK_SYSTEMS]: TEK_SYSTEMS,
    [BrandId.CONNECTED]: CONNECTED,
};
export const EMAIL_BRANDING_CONFIG = {
    actalent: ACTALENT.emailBranding,
    aerotek: AEROTEK.emailBranding,
    astoncarter: ASTON_CARTER.emailBranding,
    teksystems: TEK_SYSTEMS.emailBranding,
    connected: CONNECTED.emailBranding,
};
export const EMAIL_BRAND_MAP = {
    actalent: ACTALENT,
    aerotek: AEROTEK,
    astoncarter: ASTON_CARTER,
    teksystems: TEK_SYSTEMS,
    connected: CONNECTED,
};
export function getBrandFromHost(host) {
    for (const brand of BRANDS) {
        if (brand.hostPattern.test(host)) {
            return brand;
        }
    }
    return null;
}
export function getBrandFromEmail(email) {
    const parts = email.split("@");
    if (parts.length === 2) {
        return getBrandFromHost(parts[1]);
    }
    return null;
}
export function getPrivacyPolicyUrl(brand) {
    return new URL(brand.privacyPolicyUrl, brand.origin).href;
}
export function getTermsAndConditionsUrl(brand) {
    return new URL(brand.termsAndConditionsUrl, brand.origin).href;
}
function getBrandAllowedActivityTypes(brandId) {
    return BRANDS_BY_ID[brandId].allowedActivityTypes;
}
export function isBrandActivityTypeAllowed(brandId, activityType) {
    return getBrandAllowedActivityTypes(brandId).includes(activityType);
}
export { isValidEmailBrandKey, safeGetEmailBrandKey, } from "./helpers/emailBrand.js";
